<template>
	<el-row type="flex" align="middle">
		<div>
			<el-button class="customer-btn" type="text" @click="triggerDetail" v-if="tableData.main">
				<popover-text
					class="account"
					:line="1"
					:text="getContent()"
					:subText="getContent()"
				></popover-text>
			</el-button>
			<div v-for="(item, index) in textList" :key="index" :style="[statusStyle]">
				<popover-text
					class="account"
					:class="item.class"
					v-if="!item.showIcon"
					:style="[item.style]"
					:textStyle="item.textStyle"
					:width="item.width"
					:line="1"
					:text="getText(item, index)"
					:colType="item.colType"
					:tableData="tableData"
					:scope="scope"
					:disabled="item.disabled"
					v-bind="item"
					:subText="getText(item, index)"
				>
				</popover-text>
				<div v-if="item.showIcon" class="cust-icon">
					<ig-icon v-if="item.custIcon" v-bind="getIconAttrs(item)"></ig-icon>
					<popover-text
						:text="item.custValue(scope.row)"
						:subText="item.custValue(scope.row)"
						v-bind="item.popover && item.popover(scope)"
					></popover-text>
				</div>
			</div>
		</div>
		<div class="data-tishi" v-if="dataHint" v-bind="dataHint" @click="iconClick">
			<ig-icon :name="dataHint.name" :style="[dataHint.iconStyle]"></ig-icon>
		</div>
	</el-row>
</template>
<script>
import popoverText from '@/components/tools/popoverText.vue';
import filters from '@/mixins/filters';
const { filters: filter } = filters;

export default {
	props: {
		tableData: Object,
		scope: Object,
	},
	components: {
		popoverText,
	},
	data() {
		return {};
	},
	computed: {
		statusStyle() {
			if (this.tableData.statusStyle) return this.tableData.statusStyle(this.scope.row);
		},
		textList() {
			if (this.tableData.text) {
				let { scope } = this;
				let text = [...this.tableData.text];
				return text.filter((item, index) => {
					if (typeof item.showItem === 'boolean') {
						return !item.showItem;
					}
					if (typeof item.showItem === 'function') {
						return !item.showItem(item, scope.row);
					}
					if (!this.scope.row[item.bind]) {
						item.disabled = true;
					} else {
						item.disabled = false;
					}
					return true;
				});
			}
		},
		dataHint() {
			if (this.tableData.dataHint) return this.tableData.dataHint(this.scope.row);
		},
	},
	methods: {
		getText(item, index) {
			if (this.tableData.formatter) {
				return this.tableData.formatter(item, this.scope.row);
			}
			// 有label 并且自定义value的判断
			if (item.label) {
				if (item && item.custValue) {
					return `${item.label}：${filter.dataListFormat(item.custValue(this.scope.row))}`;
				}
				if (this.tableData.isArr) {
					let str = '-';
					if (this.tableData.bind) {
						str =
							this.scope.row[this.tableData.bind].length > index
								? `${item.label}：${this.scope.row[this.tableData.bind][index][item.bind]}`
								: `${item.label}：-`;
					}
					return str;
				}
				// 不自定义value
				return `${item.label}：${filter.dataListFormat(this.scope.row[item.bind])}`;
			} //只自定义value
			else if (item && item.custValue) {
				return filter.dataListFormat(item.custValue(this.scope.row));
			}
			return this.scope.row[item.bind] || '-';
		},
		triggerDetail() {
			this.tableData.event && this.tableData.event(this.scope.row);
		},
		getContent() {
			const { scope, tableData } = this;
			if (tableData && tableData.custMain) return tableData.custMain(scope.row);
			let formatText = filter.isEmpty(
				scope.row[tableData.main] && scope.row[tableData.main].toString()
			);
			return formatText;
		},
		//返回的数据结构可以自定义 {name:'iconname',style:{color:red}}
		getIconAttrs(item) {
			if (item && item.custIcon) {
				const obj = item.custIcon(this.scope.row);
				return obj;
			}
		},
		iconClick() {
			let { scope, tableData } = this;
			this.dataHint.click && this.dataHint.click(scope, tableData);
		},
	},
};
</script>
<style lang="scss" scoped>
.customer-btn {
	white-space: normal;
}
.active {
	font-size: 20px;
	color: #67c23a;
}
.cust-icon {
	display: flex;
}
.data-tishi {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 10px;
}
.pad-left {
	padding-left: 20px;
	display: inline-block;
}
.no-show {
	display: none;
}
</style>
